// Client-side twin of backend `_norm_business`: strip everything but
// lowercase alphanumerics so "Home Depot", "HomeDepot", "home-depot!" all
// collapse to the same key. Kept in sync with server.py:_norm_business.
export const normBusiness = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]/g, "");

// Return the first previously-typed business that normalises to the same key
// as `input` but is spelled differently. Used to nudge the user toward the
// canonical spelling before the duplicate ever lands in the DB.
export const findBusinessDuplicate = (input, list) => {
  const inNorm = normBusiness(input);
  if (!inNorm || !Array.isArray(list)) return null;
  const trimmed = (input || "").trim();
  for (const b of list) {
    if (!b || b === trimmed) continue;
    if (normBusiness(b) === inNorm) return b;
  }
  return null;
};
